// extracted by mini-css-extract-plugin
module.exports = {"info":"info___1Is5v"};